import {LngKeys} from "@app/shared/enums";
import {FormsModule} from '@angular/forms';
import {LngRoutePipe} from "@app/shared/pipes";
import {NzIconModule} from 'ng-zorro-antd/icon';
import {Language} from "@app/shared/interfaces";
import {NgOptimizedImage} from '@angular/common';
import {NzSelectModule} from 'ng-zorro-antd/select';
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {AnalyticsService} from "@app/shared/services";
import {ShareButtonDirective} from "ngx-sharebuttons";
import {NzTooltipDirective} from "ng-zorro-antd/tooltip";
import {redirectToTranslatedPath} from "@app/shared/helpers";
import {LANGUAGES_OBJ} from "@app/shared/constants/languages_data";
import {openChat, openEmail} from "@app/shared/helpers/chat-helpers";
import {Router, RouterLink, RouterLinkActive} from '@angular/router';
import {projectMessages} from "@app/shared/constants/project-messages";
import {AppStateService} from "@app/shared/services/app-state.service";
import {DropdownComponent} from "@app/shared/ui-kits/dropdown/dropdown.component";
import {ChangeDetectionStrategy, Component, inject, Renderer2} from '@angular/core';
import {G2LoveBannerComponent} from "@app/shared/ui-kits/g2-love-banner/g2-love-banner.component";
import {ProjectSocialIconsComponent} from "@app/shared/ui-kits/project-social-icons/project-social-icons.component";

const chunkLanguages = <T>(obj: Record<string, T>, size = 5): T[][] => {
  const arr = Object.values(obj);
  const result: T[][] = [];

  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }

  return result;
}

@Component({
  selector: 'sf-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [
    RouterLink,
    FormsModule,
    NzIconModule,
    LngRoutePipe,
    NzSelectModule,
    TranslateModule,
    NgOptimizedImage,
    RouterLinkActive,
    DropdownComponent,
    NzTooltipDirective,
    ShareButtonDirective,
    ProjectSocialIconsComponent,
    G2LoveBannerComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
  private readonly router = inject(Router);
  private readonly renderer = inject(Renderer2);
  private readonly analyticsService = inject(AnalyticsService);
  private readonly translateService = inject(TranslateService);
  protected readonly appStateService = inject(AppStateService);

  protected readonly projectMessages = projectMessages;

  protected readonly languages = chunkLanguages(LANGUAGES_OBJ);

  constructor() {
  }

  protected changeLanguage(event: Language) {
    this.appStateService.setLng(event.key);
    this.appStateService.setHtmlLangAttribute(event.key, this.renderer);
    this.appStateService.addMetaTags(LANGUAGES_OBJ[event.key as LngKeys].seo);

    redirectToTranslatedPath(this.router, event.key, this.appStateService);
  }

  protected trustPilotReviewClicked() {
    this.analyticsService.track('trustPilot_review_clicked');
  }

  protected trackResumeTool(action: 'ai_generator' | 'ats_checker') {
    this.analyticsService.track('footer_resume_tool_clicked', {
      action,
      placement: 'footer',
      language: this.translateService.currentLang || LngKeys.EN,
      is_authenticated: this.appStateService.isAuthenticated
    });
  }

  protected openChat() {
    openChat();
  }

  protected openEmail() {
    openEmail();
  }
}
